<div id="outer">
  <div id="header">
    {{ title }}
  </div>
  <div id="message" [innerHTML]="message | safeHtml: 'html'">{{ message }}</div>
  <div id="button-container">
    <button
      class="button_primary button_var_2"
      id="ok-button"
      (click)="dialogRef.close('OK')"
      (keydown.enter)="dialogRef.close('OK')"
      type="submit"
      color="accent"
    >
      OK
    </button>
  </div>
</div>
